<template>
  <div class="record-item">
    <div class="content">
      <div class="title">{{ formatTimestamp(item.subTime, false) }}</div>
      <div class="time">{{ formatTimestamp(item.subTime) }}</div>
    </div>
    <div class="type">审核通过</div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    formatTimestamp(timestamp, isDateTime = true) {
      const timestampInMilliseconds = timestamp * 1000
      const date = new Date(timestampInMilliseconds)

      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      const insertZero = num => {
        return num < 10 ? '0' + num : num
      }
      month = insertZero(month)
      day = insertZero(day)
      hour = insertZero(hour)
      minute = insertZero(minute)
      second = insertZero(second)

      return isDateTime
        ? `${year}-${month}-${day} ${hour}:${minute}:${second}`
        : `${year}-${month}-${day}`
    }
  }
}
</script>

<style lang="scss" scoped>
.record-item {
  display: flex;
  justify-content: space-between;
  padding: 0.32rem;
  .content {
    .title {
      font-size: 0.32rem;
      color: #262626;
      margin-bottom: 0.1rem;
    }
    .time {
      font-weight: 400;
      font-size: 0.24rem;
      color: #8c8c8c;
    }
  }
  .type {
    font-weight: 400;
    font-size: 0.28rem;
    color: #00a64b;
  }
}
</style>
